










































import { Component, Prop } from "vue-property-decorator";
import { AgGridVue } from "ag-grid-vue";
import ImportGridFooter from "@/components/_shared/import-csv/import-grid-footer.vue";
import GridBoolComponent from "@/components/_shared/grid-components/grid-cells/grid-bool-component.vue";
import ImportGridHeader from "@/components/_shared/import-csv/import-grid-header.vue";
import { ImportGrid } from "@/utils/grid/import-grid-helper";
import router from "@/router/router";
import {MessageType} from "@/components/_shared/template/app-snackbar.vue";
import ImportGridReport from "@/components/_shared/import-csv/import-grid-report.vue";

@Component({
  name: "common-import-csv-page",
  components: {
    ImportGridReport,
    ImportGridHeader,
    ImportGridFooter,
    AgGridVue,
    GridBoolComponent,
  },
})
export default class CommonImportCsvPage extends ImportGrid {
  @Prop() dataLabel: string;
  @Prop({default: false}) report: boolean;
  private reportData: object = null

  async beforeMount() {
    this.reportData = null;
    await super.beforeMount();
  }

  async onValidate() {
    const response = await super.onValidate(new FormData(), !this.report);
    if (!response) return;
    const {data} = response;
    if (data && data.report) {
      // L'api peut renvoyer `result: "error"` sans ligne en erreur dans le rapport (ex. client manquant).
      if (data.result !== 'error' && !data.report.some(r => r.status === 'error')) {
        this.$eventHub.$emit("show-snackbar", { type: MessageType.success, mainText: this.$t("import_csv.success_snackbar") })
        await router.push(this.previousRoute);
        return;
      }

      if (!data.report.some(r => r.status === 'error')) {
        this.$eventHub.$emit("show-snackbar", { type: MessageType.error, mainText: this.$t("import_csv.error_snackbar") })
        return;
      }

      this.$eventHub.$emit("show-snackbar", { type: MessageType.warning, mainText: this.$tc("import_csv.incorrect_text", data.report.length) })
      this.reportData = data;
    }
  }
}
